<script>
import api from '@/helpers/api'
export default {
  name: 'product-card.generic',
  props: {
    product: { type: Object, required: true }
  },
  data: () => ({
    files: [],
    hovered: false
  }),
  mounted () {
    this.fetchProductFiles()
  },
  methods: {
    onHoverHandler (hover) {
      this.hovered = hover
    },
    async fetchProductFiles () {
      let { items } = await api.productFiles.fetchPage({
        page: 1,
        pageSize: 5,
        filters: [
          { product_id: { _eq: this.product.id } },
          { file: { file_content_type: { _ilike: 'image/%' } } }
        ]
      })

      this.files = [
        ...items.map(f => ({
          ...f.file,
          name: f.file.file_name,
          size: f.file.file_size,
          type: f.file.file_content_type
        }))
      ]
    }
  }
}
</script>
<template>
  <div
    class="p-0 m-0"
    v-b-hover="onHoverHandler"
    :class="{ 'bg-light': hovered }"
  >
    <b-card
      no-body
      class="product--card bg-transparent rounded-sm shadow-none pointer flex-column p-3 m-0"
      v-on:click="
        $router.push({
          name: 'sales.shop.product',
          params: { id: product.id }
        })
      "
    >
      <app-file-image
        :file="files[0]"
        class="card-img-top border"
        v-if="files[0]"
        height="130px"
        width="auto"
      />
      <g-no-file-image
        v-else
        class="card-img-top border"
        height="130px"
        width="auto"
      />

      <div class="flex-column p-2">
        <h6>
          {{ product.code }}
          <i
            class="bx bxs-star text-info font-size-14"
            v-if="product.is_favorite"
          />
        </h6>
        <small class="d-block text-truncate">{{
          product.short_description
        }}</small>

        <b-badge
          v-if="product.category"
          class="my-2 text-uppercase"
          style="font-size:0.5rem;"
          variant="primary"
          >{{ product.category.name }}</b-badge
        >
      </div>

      <b-card-footer
        footer-bg-variant="white"
        class="border-top p-2"
        v-if="false"
      >
        <div class=" d-flex align-items-end justify-content-end">
          <b-btn
            size="sm"
            variant="secondary"
            class=" d-flex align-items-center btn-label"
          >
            <i class="bx bx-cart label-icon"></i>Add to cart
          </b-btn>
        </div>
      </b-card-footer>
    </b-card>
  </div>
</template>

<style lang="scss">
.product--card {
  position: relative;

  .favorite {
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px;
  }
}
</style>
